import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  LoadingWrapper,
  StyledLottie,
  TextWrapper,
  TitleText
} from './LoadingContractValidation.styles';

import LOADING_CONTRACT_LOTTIE from '@/assets/lotties/loading_contract.json';
import { useOnboardingFormLogic } from '@/hooks';
import { useUserOnboarding, useMutateUserOnboarding } from '@/store';

const MIN_LOADING_TIME = 3000;
const POLLING_INTERVAL = 1000;

export const LoadingContractValidaton = () => {
  const { t } = useTranslation('StudentOnboardingPageTranslations');
  const { markContractAsSigned } = useMutateUserOnboarding();
  const { userOnboarding: onboarding, refetch: refetchOnboarding } = useUserOnboarding();
  const { stopLoadingAfterContract, handleNextStep } = useOnboardingFormLogic();
  const [isLoading, setIsLoading] = useState(true);
  const [hasUpdatedContract, setHasUpdatedContract] = useState(false);

  const handleContractUpdate = () => {
    if (!hasUpdatedContract) {
      setHasUpdatedContract(true);
      markContractAsSigned(undefined, {
        onSuccess: () => {
          refetchOnboarding();
          stopLoadingAfterContract();
          handleNextStep();
        }
      });
    }
  };

  useEffect(() => {
    const pollingInterval = setInterval(async () => {
      await refetchOnboarding();
      if (onboarding?.contract?.contractFile) {
        clearInterval(pollingInterval);
      }
    }, POLLING_INTERVAL);

    const minLoadingTimer = setTimeout(() => {
      if (onboarding?.contract?.contractFile) {
        clearInterval(pollingInterval);
      }
      setIsLoading(false);
    }, MIN_LOADING_TIME);

    return () => {
      clearInterval(pollingInterval);
      clearTimeout(minLoadingTimer);
    };
  }, [onboarding?.contract?.contractFile, refetchOnboarding]);

  useEffect(() => {
    const contractCorrect = onboarding?.contract?.contractFile;
    const notProd = !import.meta.env.PROD;
    const finishLoading = !isLoading && (contractCorrect || notProd);
    if (finishLoading) {
      handleContractUpdate();
    }
  }, [isLoading, onboarding?.contract?.contractFile]);

  return (
    <LoadingWrapper>
      <StyledLottie animationData={LOADING_CONTRACT_LOTTIE} autoPlay loop />
      <TextWrapper>
        <TitleText>{t('LOADING_APP_TITLE')}</TitleText>
      </TextWrapper>
    </LoadingWrapper>
  );
};
